import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import en from "../translation/en.json";
import { isAppLanguage } from "../../utils/languages";

// Astria app-shell copy lives in the shared locale files under "astria.*",
// translated for every app language, so this shell never falls back to
// another language.
export type CopyKey = keyof typeof en.astria;

/** Maps a locale code (e.g. "pt-BR", "zh-CN") onto an app language code. */
export const resolveAstriaLang = (code?: string): string => {
  const base = (code || "en").toLowerCase().split("-")[0];
  return isAppLanguage(base) ? base : "en";
};

export const astriaText = (key: CopyKey, lang: string): string =>
  i18n.t(`astria.${key}`, { lng: resolveAstriaLang(lang) });

/** Copy for the Astria app shell in the user's preferred language. */
export const useAstriaCopy = () => {
  const { t } = useTranslation();
  return (key: CopyKey) => t(`astria.${key}`);
};
